var map = {
	"./imgi_100_frekvencije_poledica_Srbija_1991.jpg": 505684,
	"./imgi_101_frekvencije_poledica_Srbija_1992.jpg": 716244,
	"./imgi_102_frekvencije_poledica_Srbija_1993.jpg": 796035,
	"./imgi_103_frekvencije_poledica_Srbija_1994.jpg": 19484,
	"./imgi_104_frekvencije_poledica_Srbija_1995.jpg": 109464,
	"./imgi_105_frekvencije_poledica_Srbija_1996.jpg": 53108,
	"./imgi_106_frekvencije_poledica_Srbija_1997.jpg": 302076,
	"./imgi_107_frekvencije_poledica_Srbija_1998.jpg": 194188,
	"./imgi_108_frekvencije_poledica_Srbija_1999.jpg": 395748,
	"./imgi_109_frekvencije_poledica_Srbija_2000.jpg": 805968,
	"./imgi_110_frekvencije_poledica_Srbija_2001.jpg": 254116,
	"./imgi_111_frekvencije_poledica_Srbija_2002.jpg": 37100,
	"./imgi_112_frekvencije_poledica_Srbija_2003.jpg": 825652,
	"./imgi_113_frekvencije_poledica_Srbija_2004.jpg": 661844,
	"./imgi_114_frekvencije_poledica_Srbija_2005.jpg": 59724,
	"./imgi_115_frekvencije_poledica_Srbija_2006.jpg": 318540,
	"./imgi_116_frekvencije_poledica_Srbija_2007.jpg": 382648,
	"./imgi_117_frekvencije_poledica_Srbija_2008.jpg": 97880,
	"./imgi_118_frekvencije_poledica_Srbija_2009.jpg": 387544,
	"./imgi_119_frekvencije_poledica_Srbija_2010.jpg": 90456,
	"./imgi_120_frekvencije_poledica_Srbija_2011.jpg": 369416,
	"./imgi_121_frekvencije_poledica_Srbija_2012.jpg": 49896,
	"./imgi_122_frekvencije_poledica_Srbija_2013.jpg": 672288,
	"./imgi_123_frekvencije_poledica_Srbija_2014.jpg": 529972,
	"./imgi_124_frekvencije_poledica_Srbija_2015.jpg": 520668,
	"./imgi_125_frekvencije_poledica_Srbija_2016.jpg": 451884,
	"./imgi_126_frekvencije_poledica_Srbija_2017.jpg": 513748,
	"./imgi_127_frekvencije_poledica_Srbija_2018.jpg": 281648,
	"./imgi_128_frekvencije_poledica_Srbija_2019.jpg": 419252,
	"./imgi_129_frekvencije_poledica_Srbija_2020.jpg": 442236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 998627;